import React from 'react';
import CmpAnalyticsKpis from "./CmpAnalyticsKpis";
import Tabs from "../../Tabs";
import {Col, Row} from "react-bootstrap";
import ConsentDataByDay from "./ConsentDataByDay";
import ConsentByPurpose from "./ConsentByPurpose";
import ConsentOutputChart from "./ConsentOutputChart";
import ConsentByOsChart from "./ConsentByOsChart";
import ConsentRequestByLangChart from "./ConsentRequestByLangChart";
import ConsentByLangChart from "./ConsentByLangChart";
import ConsentRequestByRankChart from "./ConsentRequestByRankChart";
import ConsentByRankChart from "./ConsentByRankChart";
import ConsentBySdkTable from "./ConsentBySdkTable";
import ConsentByAppTable from "./ConsentByAppTable";
import ConsentByLayoutTable from "./ConsentByLayoutTable";
import ConsentRequestByLayoutChart from "./ConsentRequestByLayoutChart";
import ConsentByVendorTable from "./ConsentByVendorTable";
import ConsentRequestLayoutVersionByDayChart from "./ConsentRequestLayoutVersionByDayChart";


const ConsentTab = ( {dataByDay, dataByPurpose, dataByOs, consentsOutput, requestsByLang, dataByLang, requestsByRank, dataByRank} ) => {

  return (
    <>
      <ConsentDataByDay {...dataByDay} />
      <ConsentByPurpose {...dataByPurpose} />
      <Row>
        <Col>
          <ConsentOutputChart {...consentsOutput} />
        </Col>
        <Col>
          <ConsentByOsChart {...dataByOs} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ConsentRequestByLangChart {...requestsByLang} />
        </Col>
        <Col>
          <ConsentByLangChart {...dataByLang} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ConsentRequestByRankChart {...requestsByRank} />
        </Col>
        <Col>
          <ConsentByRankChart {...dataByRank} />
        </Col>
      </Row>
    </>
  )
}

export const ConsentLayoutTab = ( {dataByLayout, dataByLayoutByDay, requestsByLayout} ) => {

  return (
    <>
      <ConsentByLayoutTable {...dataByLayout} />
      <Row>
        <Col>
          <ConsentRequestLayoutVersionByDayChart {...dataByLayoutByDay} />
        </Col>
        <Col>
          <ConsentRequestByLayoutChart {...requestsByLayout} />
        </Col>
      </Row>
    </>
  )
}


const CmpAnalyticsDashboardContainer = ({kpis, analytics, children}) => {

  return <>
    <CmpAnalyticsKpis data={kpis} />
    <Tabs active={"devices"}>
      <ConsentTab as="consent" icon="consent"
                  dataByDay={analytics.dataByDay}
                  dataByPurpose={analytics.dataByPurpose}
                  dataByOs={analytics.dataByOs}
                  consentsOutput={analytics.consentsOutput}
                  dataByLang={analytics.dataByLang}
                  requestsByLang={analytics.requestsByLang}
                  dataByRank={analytics.dataByRank}
                  requestsByRank={analytics.requestsByRank}/>
      <ConsentBySdkTable as="sdk" icon="code" {...analytics.dataBySdk}/>
      <ConsentByVendorTable as="vendor" icon="vendor" {...analytics.dataByVendor}/>
      {children}
    </Tabs>
  </>
}

export default CmpAnalyticsDashboardContainer
